import moment from "moment";

export const mapModelToBooking = (model, customerId) => {
	const {
		customer,
		eventInformation,
		paymentMethod,
		package: { id: eventId, costPerPerson },
	} = model;
	const { slot, numberOfGuests, eventDate } = eventInformation;
	const { address } = customer;

	const out = {
		customerId,
		eventDate: moment(eventDate).format(),
		eventId,
		eventStartTime: slot.start,
		eventEndTime: slot.end,
		slotId: slot.slotId,
		numberOfGuests: parseInt(numberOfGuests),
		bookingPayments: {
			create: {
				amount: numberOfGuests * costPerPerson,
			},
		},
	};

	if (!paymentMethod.id) {
		const newPaymentMethod = {
			create: {
				customerId,
				creditCard: {
					create: paymentMethod.card,
				},
				externalId: "",
			},
		};

		if (address.id) {
			newPaymentMethod.create.addressId = address.id;
		} else {
			const customerAddress = {
				create: {
					customerId,
					firstName: address.firstName,
					lastName: address.lastName,
					phone: address.phone,
					addressLine1: address.addressLine1,
					addressLine2: address.addressLine2,
					city: address.city,
					stateId: address.stateId,
					zipCode: address.zipCode,
					countryId: address.countryId,
				},
			};

			newPaymentMethod.create.customerAddress = customerAddress;
		}

		out.bookingPayments.create.paymentMethod = newPaymentMethod;
	}

	return out;
};
